import { useState, useCallback } from 'react';
import { YouTubePlayer } from 'react-youtube';

export const useYouTubeVideoControls = () => {
  const [youtubeVideoElements] = useState<Map<string, YouTubePlayer>>(new Map());

  const handleYoutubeReady = useCallback(
    (videoUrl: string, player: YouTubePlayer) => {
      youtubeVideoElements.set(videoUrl, player);
    },
    [youtubeVideoElements]
  );

  const stopVideos = useCallback(() => {
    youtubeVideoElements.forEach((ytPlayer: YouTubePlayer) => {
      if (ytPlayer && typeof ytPlayer.stopVideo === 'function') {
        ytPlayer.stopVideo();
      }
    });
  }, [youtubeVideoElements]);

  return { handleYoutubeReady, stopVideos };
};
